import { createContext, useState } from 'react';

const ALERT_TIME = 5000;

const initialState = {
    text: '',
    type: '',
};

type AlertType = 'error' | 'success' | 'warning' | 'info';

export const AlertContext = createContext({
    ...initialState,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    setAlert: (_text: string, _type: AlertType, _timeout?: number) => {},
});

interface AlertProviderProps {
    children: React.ReactNode;
}

export const AlertProvider = ({ children }: AlertProviderProps) => {
    const [text, setText] = useState('');
    const [type, setType] = useState('');

    const setAlert = (text: string, type: string, timeout?: number) => {
        setText(text);
        setType(type);

        setTimeout(() => {
            setText('');
            setType('');
        }, timeout || ALERT_TIME);
    };

    return (
        <AlertContext.Provider
            value={{
                text,
                type,
                setAlert,
            }}>
            {children}
        </AlertContext.Provider>
    );
};
